import api from './apiService';

export const getAccountResume = async () => {
    try {
        const response = await api.get('/dashboard/account-resume');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getUsersResume = async () => {
    try {
        const response = await api.get('/dashboard/users-resume');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}